<template>
  <section v-if="form">
    <el-form ref="form" label-width="130px" class="form info-txt-center" style="padding-top:0;overflow:hidden;">

      <el-form-item label="申请编号:">
        {{ form.number }}
      </el-form-item>
      <div v-if="form.type=='2'">
        <!-- 子公司采购 -->
        <el-form-item label="申请部门:">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="申请时间:">
          {{ getTime(form.flow.createTime) }}
        </el-form-item>
        <el-form-item label="采购项目:">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="招标方式:">
          {{ form.zbfs }}
        </el-form-item>

        <el-form-item label="供货单位:">
          {{ form.ghdw }}
        </el-form-item>
        <el-form-item label="供货期限:">
          {{ form.ghqx }}
        </el-form-item>
        <el-form-item label="合同总价:">
          {{ form.htzj }}
        </el-form-item>
        <el-form-item label="本次采购批次:">
          {{ form.bccgpc }}
        </el-form-item>
        <el-form-item label="本次采购价:">
          {{ form.bccgj }}
        </el-form-item>
        <el-form-item label="已经采购价:">
          {{ form.yjcgh }}
        </el-form-item>
        <el-form-item label="至本次采购总价:">
          {{ form.zbccgzj }}
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="申请部门:" v-if="form.type=='0'">
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请单位:" v-else>
          {{form.department.name}}
        </el-form-item>
        <el-form-item label="申请人:">
          <user-info :userData='form.creator'></user-info>
        </el-form-item>
        <el-form-item label="申请时间:">
          {{ getTime(form.flow.createTime) }}
        </el-form-item>
        <el-form-item label="采购项目:">
          {{ form.name }}
        </el-form-item>
        <el-form-item label="招标方式:" v-if="form.type!='2'">
          {{ form.zbfs }}
        </el-form-item>
        <el-form-item class="full" label="采购内容:">
          <div class="material-table">
            <el-table :data="form.purchaseItems" border>
              <el-table-column prop="name" label="采购名称">
              </el-table-column>
              <el-table-column prop="spec" label="规格型号">
              </el-table-column>
              <el-table-column prop="amount" align="center" label="数量">
              </el-table-column>
              <el-table-column prop="price" label="单价">
              </el-table-column>
              <el-table-column prop="fee" align="center" label="金额">
              </el-table-column>
              <el-table-column prop="remark" align="center" label="备注">
              </el-table-column>
            </el-table>
          </div>
          <div class="total-price">
            总价：<span>{{ total }}</span> &nbsp;&nbsp;&nbsp;&nbsp;大写金额：<span>{{ form.price }}</span>
          </div>
        </el-form-item>

      </div>

      <el-form-item class="full" label="采购原因:">
        {{ form.reason }}
      </el-form-item>
    </el-form>
  </section>
</template>
<script>
  import UserInfo from '@/components/UserInfo'
  export default {
    components: {
      UserInfo,
    },
    computed: {
      total: function () {
        var _total = 0
        for (var i = 0; i < this.form.purchaseItems.length; i++) {
          var _item = this.form.purchaseItems[i]
          _total += _item.fee / 1
        }
        return _total.toFixed(2)
      }
    },
    props: ['form', 'flowUser'],
    data() {
      return {
        // total: ''  
      }
    },
    methods: {
      getTime(t) {
        return util.getFormatDate(t, true)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/page/purchase/components/purchaseApplyDetail.vue